export const transformActionType = (actionType) => {
  return actionType
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const getApprovalDescription = (item) => {
  if (item.edits_made) {
    if (item.action_type === 'soft_limit_breach') {
      // Iterate over all fields in edits_made and show all values for soft limit breaches
      const edits = item.edits_made;
      if (edits && typeof edits === 'object' && !Array.isArray(edits)) {
        // If the edits object contains multiple fields (as in the example), iterate and show all
        return Object.entries(edits)
          .map(([field, details]) => {
            if (typeof details === 'object' && details !== null && 'value' in details) {
              const priceName = field.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
              const value = details.value;
              const softLimit = details.soft_limit;
              const type = details.type === 'percent' ? '%' : '$';
              return `${priceName}: ${type}${value} (Soft limit: ${type}${softLimit})`;
            }
            return null;
          })
          .filter(Boolean)
          .join('; ');
      } 
    }
    if (item?.action_type === 'editing_metadata') {
      return `Request to update ${item.edits_made?.field} from "${item.edits_made?.old_value}" to "${item.edits_made?.new_value}".`;
    }
    if (item?.action_type === 'send_for_signature') {
      return `Document "${item.edits_made?.file_title}" needs to be sent for signature to Merchant.`;
    }
  }
  return 'Approval required for this action.';
};